<template>
    <v-simple-table>
        <template v-slot:default>
        <thead>
            <tr>
            <th class="text-left">Producto</th>
            <th class="text-left">Cantidad</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="item in items" :key="item.name">
            <td>{{ item.name }}</td>
            <td>{{ item.quantity }}</td>
            </tr>
        </tbody>
        </template>
    </v-simple-table>
</template>

<script>
export default {
    props:['products'],
    data: () => ({
        items : []
    }),

    created() {
      this.updateItems(this.products)
    },

    watch : {
        products : function(products) {
            this.updateItems(products);
        }
    },

    methods: {
        updateItems(products) {
            this.items.splice(0);
            products.map( (element) => {
                for (let i = 0; i < this.items.length; i++) {
                    if(element.name == this.items[i].name){
                        this.items[i].quantity++;
                        return;
                    }
                }
                this.items.push({name: element.name, quantity:1});
            })
            this.items.sort((a, b) => a.name.localeCompare(b.name))
        }
    }
}
</script>